import { createStore } from 'vuex'
import abi from './utils/shroomAbi.json'
import abi2 from './utils/shroomItems.json';
import abi3 from './utils/mushroomHuntABI.json';

export default createStore({
  state: {
    account: null,
    error: null,
    mining: false,
    currentNetwork: null,
    contract_address: '0x821098552Aee8eC28a7986e6a0AB666dA5F43edF',
    contract_abi: abi.abi,
    shroomItems_address: '0xE898e436fDC51ada2100cCf94820B964722f4032',
    shroomItems_abi: abi2.abi,
    accessoryHandling_Contract: '0x25B462eDD709C9643001D2c938033A315FF1BBfD',
    mushroomHuntContract: '0x0f837AF78e92C0270887dcf661EF8E6f664ABbCa',
    mushroomHuntABI: abi3.abi
  },
  mutations: {
    setAccount(state, account) {
      state.account = account;
    },
    setError(state, error) {
      state.error = `${error}`;
    },
    setNetwork(state, network) {
      state.currentNetwork = `${network}`;
    },
  },
  actions: {
    async connect({ commit, dispatch }, connect) {
      try {
        const { ethereum } = window;

        if(!ethereum){
          commit("setError", "Metamask not installed!");
          return;
        }

        if(!(await dispatch("checkIfConnected") && connect)) {
          await dispatch("requestAccess");
        }

        await dispatch("checkNetwork");

      } catch(error) {
        //console.log(error);
        commit("setError", "Account request refused.");
      }
    },
    async checkNetwork({ commit, dispatch }) {
        let chainId = await ethereum.request({ method: "eth_chainId" });
        const rinkebyChainId = "0x13881";
        if(chainId !== rinkebyChainId){
          if(!(await dispatch("switchNetwork"))) {
            commit("setNetwork", chainId);
            commit("setError", "You are not connected to the Rinkeby Test Network.");
          } else {
            chainId = await ethereum.request({ method: "eth_chainId" });
            commit("setNetwork", chainId);
          }
        } else {
          commit("setNetwork", chainId);
        }
      },
    async switchNetwork() {
      try {
        await ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x13881" }]
        });

      return 1;
      } catch(error){
        commit("setError", error);
        return 0;
      }
    },
    async checkIfConnected({ commit }) {
      const { ethereum } = window;
      const accounts = await ethereum.request({ method: "eth_accounts" });

      if(accounts.length !== 0) {
        commit("setAccount", accounts[0]);
        return 1;
      } else {
        return 0;
      }
    },
    async requestAccess({ commit }) {
      const { ethereum } = window;
      const accounts = await ethereum.request({ method: "eth_requestAccounts" });
      commit("setAccount", accounts[0]);
    }
  },
  modules: {
  }
})
